import {
  Account,
  PaymentFormField,
  PaymentMethodConfiguration,
} from '@cashier/cashier-model';

import { GeneralConfigurationEnricher } from '../configurationEnricher';

interface FormFieldProviderContext {
  country: string;
  platform: string;
}

export const FormFieldProvider = {
  provideEnriched: (
    methodConfiguration: PaymentMethodConfiguration,
    currentAccount: Account | null,
    accountOptions: Account[],
    { country, platform }: FormFieldProviderContext,
  ): PaymentFormField[] => {
    const { inputs, account_form_inputs, preprocessor } = methodConfiguration;

    const sourceFields = currentAccount ? account_form_inputs : inputs;

    const context = {
      currentAccount,
      accountOptions,
      country,
      platform,
      preprocessor,
    };

    const fieldConfiguration = new Map(
      sourceFields.map((field) => [
        field.name,
        {
          ...field,
          params: field.params ? { ...field.params } : undefined,
        },
      ]),
    );

    GeneralConfigurationEnricher.enrich(fieldConfiguration, context);

    return Array.from(fieldConfiguration.values());
  },
};
